const GET_ERRORS = 'GET_ERRORS';
export { GET_ERRORS as default };
